import { render, staticRenderFns } from "./PropertyCalendarPicker.vue?vue&type=template&id=53e154ea&"
import script from "./PropertyCalendarPicker.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e154ea')) {
      api.createRecord('53e154ea', component.options)
    } else {
      api.reload('53e154ea', component.options)
    }
    module.hot.accept("./PropertyCalendarPicker.vue?vue&type=template&id=53e154ea&", function () {
      api.rerender('53e154ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertyCalendarPicker.vue"
export default component.exports